ConnectStore = require 'components/enhancers/connect_store'
DynamicHeightContainer = require 'components/common/dynamic_height_container'
EditableQuestionsList =
  require 'components/evidence_syntheses/questions_list/connected_editable_questions_list'
MiniDocumentListItem = require 'components/mini_ds/mini_document_list_item'
OrganizationsStore = require 'stores/organizations_store'
QuestionsStore = require 'stores/questions_store'
Spinner = require 'components/common/spinner'
{ MINI_DOCUMENT_DOC } = require 'lib/db_docs/doc_types'
{ useI18n } = require 'lib/react_utils'

questionGroups = Immutable.fromJS({ groups: [], mapping: {} })

storeConnector =
  QuestionsStore: (Store, props) ->
    isFetchingQuestions: Store.isFetching()
    questions: Store.getSortedQuestionsByKey props.documentType or MINI_DOCUMENT_DOC
  OrganizationsStore: (Store) ->
    projectFromOrganization: Store.isCurrentProjectFromOrganization()

MiniDocumentsList = ({
  isFetchingQuestions
  isFetchingStatuses
  projectFromOrganization
  questions
  documentType
}) ->
  i18n = useI18n 'docsec'
  return <Spinner /> if isFetchingQuestions or isFetchingStatuses
  <div className='comparison-questions-list'>
    <div>
      <DynamicHeightContainer>
        <EditableQuestionsList
          customNewGroupLabel={i18n 'new_group_area'}
          projectFromOrganization={projectFromOrganization}
          questions={questions}
          questionGroups={questionGroups}
          withNewGroupDropArea={false}
          withDnD={false}
        >
          <MiniDocumentListItem documentType={documentType} />
        </EditableQuestionsList>
      </DynamicHeightContainer>
    </div>
  </div>


MiniDocumentsList.propTypes =
  isFetchingQuestions: PropTypes.bool.isRequired
  isFetchingStatuses: PropTypes.bool.isRequired
  projectFromOrganization: PropTypes.bool.isRequired
  questions: PropTypes.oneOfType([
    PropTypes.instanceOf(Immutable.OrderedMap),
    PropTypes.instanceOf(Immutable.Map)]
  ).isRequired

module.exports = ConnectStore MiniDocumentsList, [
  OrganizationsStore
  QuestionsStore
], storeConnector
